import { render, staticRenderFns } from "./player_stat.vue?vue&type=template&id=67ceb818&scoped=true&"
import script from "./player_stat.vue?vue&type=script&lang=js&"
export * from "./player_stat.vue?vue&type=script&lang=js&"
import style0 from "./player_stat.vue?vue&type=style&index=0&id=67ceb818&scoped=true&lang=css&"
import style1 from "./player_stat.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ceb818",
  null
  
)

export default component.exports